export const modalTypes = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
}
